import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import Dashboard from "@v/dashboard.vue";
import { useAuthStore } from "@/store/auth";

const routes: RouteRecordRaw[] = [
    {
        path: "/",
        name: "Dashboard",
        component: Dashboard,
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("@v/auth/login.vue"),
    },
    {
        path: "/calendar",
        name: "Calendar",
        component: () => import("@v/calendar.vue"),
    },
    {
        path: "/cms/conferences",
        name: "CmsConferences",
        component: () => import("@v/cms/conferences.vue"),
    },
    {
        path: "/cms/conferences/:id",
        name: "CmsConference",
        component: () => import("@v/cms/conference.vue"),
        props: true,
    },
    {
        path: "/cms/reports",
        name: "CmsReports",
        component: () => import("@v/cms/reports.vue"),
    },
    {
        path: "/sacs/individuals",
        name: "SacsIndividuals",
        component: () => import("@v/sacs/individuals.vue"),
    },
    {
        path: "/sacs/individuals/:id",
        name: "SacsIndividual",
        component: () => import("@v/sacs/individual.vue"),
        props: true,
    },
    {
        path: "/sacs/colleagues",
        name: "SacsColleagues",
        component: () => import("@v/sacs/colleagues.vue"),
    },
    {
        path: "/sacs/colleagues/:id",
        name: "SacsColleague",
        component: () => import("@v/sacs/colleague.vue"),
        props: true,
    },
    {
        path: "/sacs/conferences",
        name: "SacsConferences",
        component: () => import("@v/sacs/conferences.vue"),
    },
    {
        path: "/sacs/conferences/:id",
        name: "SacsConference",
        component: () => import("@v/sacs/conference.vue"),
        props: true,
    },
    {
        path: "/sacs/reports",
        name: "SacsReports",
        component: () => import("@v/sacs/reports.vue"),
    },
    {
        path: "/sacs/email",
        name: "SacsEmail",
        component: () => import("@v/sacs/email.vue"),
    },
    {
        path: "/sacs/quality",
        name: "SacsQuality",
        component: () => import("@v/sacs/quality.vue"),
    },
    {
        path: "/admin/lookups",
        name: "Lookups",
        component: () => import("@v/admin/lookups.vue"),
    },
    {
        path: "/admin/facility-menus",
        name: "FacilityMenus",
        component: () => import("@v/admin/facility-menus.vue"),
    },
    {
        path: "/admin/users",
        name: "Users",
        component: () => import("@v/admin/users.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to) => {
    if (to.name === "Login") {
        return true;
    }

    const auth = useAuthStore();
    await auth.ensureLoaded();
    if (!auth.user) {
        return { name: "Login", query: { redirect: to.fullPath } };
    }
    return true;
});

export default router;
